import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "list-unstyled list-group" }
const _hoisted_2 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_3 = { class: "list-inline" }
const _hoisted_4 = { class: "badge badge-pill badge-dark py-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tag" }, null, -1)
const _hoisted_6 = { class: "d-flex align-items-center mb-4 d-none" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times" }, null, -1)
const _hoisted_9 = { class: "p-float-label d-inline-block" }
const _hoisted_10 = ["for"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "-", -1)
const _hoisted_12 = { class: "p-float-label d-inline-block" }
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  key: 1,
  class: "list-group-item p-0"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus align-middle" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle ml-2" }, "Add", -1)

import { AgeBrackets } from '@/interfaces/Brandlift';

import Button from "primevue/button";
import InputNumber from 'primevue/inputnumber';


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'update:modelValue', ageBrackets: AgeBrackets): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: AgeBrackets;
}





const ageMin = 18;

function addAgeBracket(): void {
	if (0 === props.modelValue.length) {
		emit('update:modelValue', [{
			lowerBound: ageMin,
			upperBound: undefined
		}]);

		return;
	}

	const min = props.modelValue[props.modelValue.length - 1].upperBound

	emit('update:modelValue', [
		...props.modelValue,
		{
			lowerBound: 1 + min,
			upperBound: undefined
		}
	]);
}

function removeAgeBracket(i: number): void {
	emit('update:modelValue', props.modelValue.toSpliced(i, 1));
}

function getLowerBoundMin(i: number): number {
	if (i === 0) {
		return ageMin;
	}

	const prev = props.modelValue[i - 1];
	if (undefined === prev || undefined === prev.upperBound) {
		return ageMin;
	}

	return 1 + prev.upperBound;
}

function getLowerBoundMax(i: number): number | undefined {
	if (props.modelValue[i].upperBound) {
		return props.modelValue[i].upperBound - 1;
	}

	return undefined;
}

function getUpperBoundMin(i: number): number | undefined {
	return props.modelValue[i].lowerBound + 1;
}

function getUpperBoundMax(i: number): number | undefined {
	const next = props.modelValue[i + 1];

	if (next && null !== next.lowerBound) {
		return next.lowerBound - 1;
	}

	return undefined;
}

function displayAgeAdd(): boolean {
	if (props.modelValue.length === 0) {
		return true
	}

	return 'number' === typeof props.modelValue[props.modelValue.length - 1].upperBound;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (__props.modelValue.length)
      ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
          _createElementVNode("ol", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (bracket, bracketIndex) => {
              return (_openBlock(), _createElementBlock("li", {
                key: 'chip-bracket-' + bracketIndex,
                class: "list-inline-item"
              }, [
                _createElementVNode("span", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(bracket.lowerBound) + _toDisplayString(bracket.upperBound ? '-' : '+') + _toDisplayString(bracket.upperBound) + " ans ", 1)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (bracket, bracketIndex) => {
      return (_openBlock(), _createElementBlock("li", {
        key: 'bracket-' + bracketIndex,
        class: "list-group-item"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, "Bracket " + _toDisplayString(bracketIndex + 1), 1),
          _createVNode(_unref(Button), {
            onClick: ($event: any) => (removeAgeBracket(bracketIndex)),
            class: "ml-auto p-button-text p-button-light p-button-secondary"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(InputNumber), {
            id: `bracket-${bracketIndex + 1}-min`,
            modelValue: bracket.lowerBound,
            "onUpdate:modelValue": ($event: any) => ((bracket.lowerBound) = $event),
            min: getLowerBoundMin(bracketIndex),
            max: getLowerBoundMax(bracketIndex),
            suffix: " ans"
          }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "min", "max"]),
          _createElementVNode("label", {
            for: `bracket-${bracketIndex + 1}-min`
          }, "min", 8, _hoisted_10)
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(InputNumber), {
            id: `bracket-${bracketIndex + 1}-max`,
            modelValue: bracket.upperBound,
            "onUpdate:modelValue": ($event: any) => ((bracket.upperBound) = $event),
            min: getUpperBoundMin(bracketIndex),
            max: getUpperBoundMax(bracketIndex),
            suffix: " ans"
          }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "min", "max"]),
          _createElementVNode("label", {
            for: `bracket-${bracketIndex + 1}-max`
          }, "max", 8, _hoisted_13)
        ])
      ]))
    }), 128)),
    (displayAgeAdd())
      ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
          _createVNode(_unref(Button), {
            onClick: addAgeBracket,
            class: "p-button-text p-button-light d-block w-100"
          }, {
            default: _withCtx(() => [
              _hoisted_15,
              _hoisted_16
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})